import { useEffect, useState } from 'react';

import PubSub from 'pubsub-js';

import { scrollToTopAppContent } from '../../../../common/utilities/common';
import { VIEW_ALL_ACCOUNT_PERMISSION } from '../../../constants';

const useUserAccountDetail = (props, userObj) => {
  const [hasAllAccountPermission, setHasAllAccountPermission] = useState(false);

  const {
    config,
    removeRegionalAccount,
    submitUpdatedAssociations,
    saveAssociations,
    postedStatus,
    updateMetaData,
    fetchAssociationData,
    removedStatus,
    fetchAccountDetails,
    reviewMode,
    metaData,
    dataPosted,
    userPermissionsData,
    isRegionalAccRemoved
  } = props;

  const getPermission = data => {
    if (data) {
      const isRegionalAllPermission = data.find(
        group => group.value.toLowerCase() === VIEW_ALL_ACCOUNT_PERMISSION && group.selected
      );
      return !!isRegionalAllPermission;
    }
    return false;
  };

  const setRegionalAllPermission = permission => setHasAllAccountPermission(!!permission);

  const removeRegAccount = (removeIndx, sfid) => {
    const { userId, email } = userObj;
    removeRegionalAccount(removeIndx, userId, email, sfid);
  };

  const saveAndSubmitUpdatedAssociations = (sfid, label) => {
    const { userId, email } = userObj;
    submitUpdatedAssociations();
    saveAssociations(userId, email, sfid, label);
  };

  useEffect(() => {
    const { userId } = userObj;
    PubSub.publish('checkFormError', false);
    if (!reviewMode) {
      fetchAssociationData(userId);
    } else {
      const hasPermission = getPermission(userPermissionsData);
      setRegionalAllPermission(hasPermission);
    }
    scrollToTopAppContent();
  }, []);

  useEffect(() => {
    const { userId, email, userType } = metaData;
    if (userObj.userId !== userId || userObj.email !== email || userObj.userType !== userType) {
      updateMetaData(userObj);
    }
  }, [userObj, metaData]);

  useEffect(() => {
    if (dataPosted) {
      PubSub.publish('xhrError', {
        text: config.messages.success
      });
      postedStatus(false);
    }
    if (isRegionalAccRemoved) {
      PubSub.publish('xhrError', {
        text: config.messages.removeSuccess
      });
      removedStatus(false);
    }
    if (userPermissionsData) {
      setHasAllAccountPermission(getPermission(userPermissionsData));
    }
  }, [userPermissionsData, isRegionalAccRemoved, dataPosted]);

  useEffect(() => {
    const isRegionalCurr = getPermission(userPermissionsData);
    setRegionalAllPermission(isRegionalCurr);
  }, [userPermissionsData]);

  const getAccountDetails = (accId, accIndex, regIndex, isAccordion, isSoldToListAvailable = []) => {
    const { email } = userObj;
    const userId = email ? btoa(email) : null;
    if (!isAccordion && !isSoldToListAvailable.length) {
      fetchAccountDetails(userId, accId, accIndex, regIndex);
    }
  };

  return {
    hasAllAccountPermission,
    saveAndSubmitUpdatedAssociations,
    removeRegAccount,
    getAccountDetails
  };
};

export default useUserAccountDetail;
